// load dependencies
import { createStore } from 'vuex';

// import default logos
import defaultReverse from "../assets/global/bellingen_holidayz_main_rev.svg";
import defaultPositive from "../assets/global/bellingen_holidayz_main_pos.svg";

// import property logos
import ivyHousePos from "../assets/dorrigo/properties/ivy_house/ivy_house_pos.png";
import ivyHouseRev from "../assets/dorrigo/properties/ivy_house/ivy_house_rev.png";

// every destination carries the main brand mark rather than a logo of its own
const destinationLogo = { positive: defaultPositive, reverse: defaultReverse };

const locationLogos = {
    bellingen: destinationLogo,
    dorrigo:   destinationLogo,
    urunga:    destinationLogo,

    // a property carries its own brand, so on its listing page it stands in for
    // the destination mark rather than sitting alongside it
    "ivy-house": {
        positive: ivyHousePos,
        reverse:  ivyHouseRev,

        // drawn to the edges of its own file, where the main mark carries about a
        // fifth of its height as clear space underneath. Set to the same compact
        // WIDTH as the main mark it stands 100px tall and hangs out of the 90px
        // sticky bar, so the sticky header fits it to the bar's height instead and
        // lets its width follow. Only the scrolled bar reads this - over a hero the
        // header is transparent and has no edge for a mark to hang past
        fitToBar: true
    }
};

export default createStore({

    debug: true,

    state() {
        return {
            location: null,
            headerLogo: {
                positive: defaultPositive,
                reverse:  defaultReverse
            }
        }
    },

     mutations: {
        storeLocation ( state, location ) {
            state.location = location;
        },
        setHeaderLogo ( state, location ) {
            if ( location && locationLogos[location] ) {
                state.headerLogo = locationLogos[location];
            } else {
                state.headerLogo = {
                    positive: defaultPositive,
                    reverse:  defaultReverse
                };
            }
        }
     },

     actions: {
        storeLocation ( context, location ) {
            context.commit( 'storeLocation', location )
        },
        setHeaderLogo ( context, location ) {
            context.commit( 'setHeaderLogo', location )
        }
     },

     getters: {
        getLocation ( state ) {
            return state.location
        },
        headerLogo ( state ) {
            return state.headerLogo
        }
     }

})
